import React, { useState, useEffect } from 'react';
import classes from './ScratchGames.module.scss';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { useSelector } from 'react-redux';

export default function DoubleMillionaire() {
  const [isLoading, setIsLoading] = useState(true);
  const token = useSelector((state) => state.scratch.token);

  useEffect(() => {
    window.onmessage = function (e) {
      if (e.data === 'noScrollBehaviour') {
        document.body.classList.add('noscroll');
      }
      if (e.data === 'ScrollBehaviour') {
        document.body.classList.remove('noscroll');
      }
    };
  }, []);

  return (
    <>
      <Header />
      <div className={classes.Iframe}>
        {isLoading && (
          <div className="loaderScratch">
            Loading Double Millionaire game...
          </div>
        )}
        <iframe
          title="Double Millionaire Game"
          src={`https://doublemillionaire-demo.moobitek.com?token=${token}`}
          allow="autoplay"
          onLoad={() => setIsLoading(false)}
          style={{
            display: isLoading ? 'none' : 'block',
          }}
        ></iframe>
      </div>
      <Footer />
    </>
  );
}
